import React from 'react';
import { BookmarkContainer } from './bookmarkStyles';
import { BookmarkIcon } from '../Icons/Icons';
import { useAppDispatch, useAppSelector } from '../../../state/hooks';
import { RootState } from '../../../state/store';
import { isEqual } from 'lodash';
import {
	BOOKMARK_ADD_TRAIL,
	BOOKMARK_DEL_TRAIL,
	BookmarkReducerAction,
} from '../../../state/bookmarksSlice';

type BookmarkButtonProps = {
	trailId: number;
};

const BookmarkTrailButton: React.FC<BookmarkButtonProps> = ({ trailId }) => {
	const dispatch = useAppDispatch();
	const bookmarkedTrails = useAppSelector(
		(state: RootState) => state.bookmarks.trails,
		isEqual,
	);

	const isBookmarked = bookmarkedTrails.includes(trailId);

	const handleToggleBookmark = () => {
		switch (isBookmarked) {
			case true:
				dispatch({
					type: BOOKMARK_DEL_TRAIL,
					payload: {
						action_id: trailId,
					},
				} as BookmarkReducerAction);
				break;

			default:
				dispatch({
					type: BOOKMARK_ADD_TRAIL,
					payload: {
						action_id: trailId,
					},
				} as BookmarkReducerAction);
		}
	};

	if (!trailId) {
		return <></>;
	} else {
		return (
			<BookmarkContainer
				onClick={() => handleToggleBookmark()}
				className={isBookmarked ? 'bookmarked' : ''}>
				<BookmarkIcon />
			</BookmarkContainer>
		);
	}
};

export default BookmarkTrailButton;
